import { useState, useEffect, useCallback } from "react"

import Language from "models/Language"
import UserService from "services/UserService"

export default function useTenantLanguages(onFail?: () => void) {
    const [languages, setLanguages] = useState<Language[] | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchLanguages = useCallback(async () => {
        setIsLoading(true)
        setLanguages(null)

        try {
            const fetchedLanguages = await UserService.getTenantLanguages()
            setLanguages(fetchedLanguages)
            setIsLoading(false)
        } catch(e) {
            if (typeof onFail === "function") {
                onFail()
            }
        }
    }, [onFail])

    useEffect(() => {
        fetchLanguages()
    }, [fetchLanguages])

    return {
        tenantLanguages: languages,
        isLoading,
    }
}
